import React, { useState } from "react";
import { Modal, Input, Button, List, Popconfirm, message } from "antd";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrash, faPlus, faSave } from "@fortawesome/free-solid-svg-icons";
import postApi from "../../../../api/postApi";

// Quản lý danh mục video: tạo / sửa tên / xoá. onChanged() để container reload categories.
function CategoryManagerModal({ open, onClose, categories, onChanged }) {
    const [newId, setNewId] = useState("");
    const [newName, setNewName] = useState("");
    const [editing, setEditing] = useState({}); // categoryId -> tên đang sửa
    const [loading, setLoading] = useState(false);

    const handleCreate = async () => {
        if (!newId.trim() || !newName.trim()) {
            message.warning("Nhập mã và tên danh mục");
            return;
        }
        setLoading(true);
        try {
            await postApi.createVideoCategories([
                { categoryId: newId.trim(), categoryName: newName.trim() },
            ]);
            message.success("Đã thêm danh mục");
            setNewId("");
            setNewName("");
            onChanged();
        } catch (e) {
            message.error("Không thể thêm danh mục");
        } finally {
            setLoading(false);
        }
    };

    const handleRename = async (categoryId) => {
        const name = (editing[categoryId] || "").trim();
        if (!name) return;
        try {
            await postApi.updateVideoCategory(categoryId, name);
            message.success("Đã cập nhật");
            setEditing((p) => {
                const n = { ...p };
                delete n[categoryId];
                return n;
            });
            onChanged();
        } catch (e) {
            message.error("Không thể cập nhật");
        }
    };

    const handleDelete = async (categoryId) => {
        try {
            await postApi.deleteVideoCategory(categoryId);
            message.success("Đã xoá danh mục (video chuyển về 'all')");
            onChanged();
        } catch (e) {
            message.error("Không thể xoá");
        }
    };

    return (
        <Modal
            title="Quản lý danh mục"
            open={open}
            onCancel={onClose}
            footer={null}
            width={620}
            style={{ top: 16, maxWidth: "calc(100vw - 16px)" }}
        >
            {/* Mobile: 2 input xuống dòng, nút Thêm full hàng */}
            <div className="flex flex-wrap gap-2 mb-4">
                <Input
                    placeholder="Mã (categoryId)"
                    value={newId}
                    onChange={(e) => setNewId(e.target.value)}
                    className="w-full sm:w-40"
                />
                <Input
                    placeholder="Tên danh mục"
                    value={newName}
                    onChange={(e) => setNewName(e.target.value)}
                    className="flex-1 min-w-[10rem]"
                />
                <Button
                    type="primary"
                    icon={<FontAwesomeIcon icon={faPlus} />}
                    loading={loading}
                    onClick={handleCreate}
                >
                    Thêm
                </Button>
            </div>

            <List
                size="small"
                bordered
                dataSource={categories}
                renderItem={(cat) => (
                    <List.Item
                        actions={[
                            <Button
                                key="save"
                                type="link"
                                icon={<FontAwesomeIcon icon={faSave} />}
                                disabled={editing[cat.categoryId] === undefined}
                                onClick={() => handleRename(cat.categoryId)}
                            >
                                Lưu
                            </Button>,
                            cat.categoryId !== "all" && (
                                <Popconfirm
                                    key="del"
                                    title="Xoá danh mục này?"
                                    onConfirm={() => handleDelete(cat.categoryId)}
                                    okText="Xoá"
                                    cancelText="Huỷ"
                                >
                                    <Button type="link" danger icon={<FontAwesomeIcon icon={faTrash} />} />
                                </Popconfirm>
                            ),
                        ]}
                    >
                        <span className="text-content-3 text-xs w-28 truncate">{cat.categoryId}</span>
                        <Input
                            size="small"
                            value={
                                editing[cat.categoryId] !== undefined
                                    ? editing[cat.categoryId]
                                    : cat.categoryName
                            }
                            onChange={(e) =>
                                setEditing((p) => ({ ...p, [cat.categoryId]: e.target.value }))
                            }
                            className="flex-1"
                        />
                    </List.Item>
                )}
            />
        </Modal>
    );
}

export default CategoryManagerModal;
